<template>
  <section class="problem-statement-section">
    <b-container>
      <b-row>
        <b-col sm="12" md="4" lg="4">
          <div class="section-img">
            <img class="section-images" src="../assets/img/problem-statement-img.png" alt="Problem statement image">
          </div>
        </b-col>
        <b-col sn="12" md="8" lg="8">
           <div class="section-content">
             <h2 class="title-section">{{$t('problem_statement_section_title')}}</h2>
             <p class="problem-content-text">
               {{$t('problem_text_1')}}
             </p>
           </div>
        </b-col>
      </b-row>
      <b-row class="margin-t-40 stretch" >
        <b-col class="card-column" sm="12" md="12" lg="4" v-for="(item, index) in cards" :key="index">
          <div class="card-info-container">
            <div class="header-card" v-html="$t(item.title)"></div>
            <div class="content-card" v-html="$t(item.content)"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      cards: [
        {
          title: 'problem_tile_card_1',
          content: 'problem_content_card_1'
        },
        {
          title: 'problem_tile_card_2',
          content: 'problem_content_card_2'
        },
        {
          title: 'problem_tile_card_3',
          content: 'problem_content_card_3'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.problem-statement-section{
  padding-top: 80px;
  padding-bottom: 48px;
  background: #FFF3F3;
  @media screen and (min-width: 320px) {
    .section-img{
      margin-bottom: 40px;
      .section-images{
        width: 100%;
        max-width: 195px;
        height: auto;
      }
    }
  }
  @media screen and (min-width: 768px) {
    .section-img{
      margin-bottom: 0;
      .section-images{
        width: 100%;
        max-width: 180px;
        height: auto;
      }
    }
  }
  @media screen and (min-width: 992px) {
    .section-img{
      margin-bottom: 0;
      .section-images{
        width: 100%;
        max-width: 195px;
        height: auto;
      }
    }
  }
  @media screen and (min-width: 1440px) {
  }
  @media screen and (min-width: 1920px) {
  }
  .section-img{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .section-content{
    .problem-content-text{
      color: #30394B;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
      margin-bottom: 0;
      @media screen and (min-width: 320px) {
        font-size: 18px;
      }
      @media screen and (min-width: 768px) {
        font-size: 16px;
      }
      @media screen and (min-width: 992px) {
        font-size: 20px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .card-column{
    margin-bottom: 32px;
  }
  .card-info-container{
    height: 100%;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0px 6.336px 15.84px 0px rgba(41, 76, 96, 0.20);
    .header-card{
      padding: 24px;
      color: #30394B;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      background: #F5ABAB;
      border-radius: 24px 24px 0px 0px;
    }
    .content-card{
      padding: 24px;
      color: #30394B;
      font-family: $main-font;
      font-size: 16px;
      font-style: normal;
      font-weight: 300;
      line-height: 22px;
    }
  }
}
</style>
